import { createTheme } from "@mui/material/styles";

const scoTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#0f4c81",
      dark: "#0a355a",
      light: "#4f82ab",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#2f6f5e",
      dark: "#214f43",
      light: "#6fa493",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f4f7fb",
      paper: "#ffffff",
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: [
      "Manrope",
      "IBM Plex Sans",
      "Segoe UI",
      "Tahoma",
      "sans-serif",
    ].join(","),
    button: {
      textTransform: "none",
      fontWeight: 700,
      letterSpacing: "0.01em",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#f4f7fb",
          color: "#1b2430",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: "#ffffff",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          boxShadow: "0 10px 24px rgba(11, 39, 70, 0.08)",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 700,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 14,
        },
      },
    },
  },
});

export default scoTheme;
